export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14262.a871fe8b.jpg";